import { CanDoAction } from '@ardoq/access-control';
import { LayoutRouteContent, PathRouteContent } from './routeNode';
import { StringParamName } from './paramRegistry';
import { UnauthorizedAccessPageProps } from '@ardoq/manage-resource-permissions';
import { ArdoqId } from '@ardoq/api-types';

export const paramResourcePermissionBoundary =
  (
    unauthorizedAccess: UnauthorizedAccessPageProps,
    action: CanDoAction,
    resourceParam: StringParamName
  ) =>
  async (): PathRouteContent =>
    (
      await import('./DeclarativePermissionBoundaryPage')
    ).buildParamResourcePermissionBoundary(
      unauthorizedAccess,
      action,
      resourceParam
    );

export const fixedResourcePermissionBoundary =
  (
    unauthorizedAccess: UnauthorizedAccessPageProps,
    action: CanDoAction,
    resourceId: ArdoqId
  ) =>
  async (): LayoutRouteContent =>
    (
      await import('./DeclarativePermissionBoundaryPage')
    ).buildFixedResourcePermissionBoundary(
      unauthorizedAccess,
      action,
      resourceId
    );
